import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import EditionModal from "@/Modals/WebDataManagement/MasterData/Editions/Modal";
import MasterDataBaseTable from "../MasterDataBaseTable";
import React from "react";
import { columns } from "./Columns";
import { editionsMasterDataApi } from "@/apis/apis";

export default function EditionsPage() {
  return (
    <MasterDataBaseTable
      label="Edition"
      apiURL={editionsMasterDataApi}
      columns={columns()}
      useLocalizationContent
      ModalComponent={EditionModal}
      importData={BASE_IMPORT_DATA.EDITIONS}
      enableStatus={false}
      enableSortData={true}
    />
  );
}
